import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m21 21-6-6m6 6v-4.8m0 4.8h-4.8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 16.2V21m0 0h4.8M3 21l6-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 7.8V3m0 0h-4.8M21 3l-6 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 7.8V3m0 0h4.8M3 3l6 6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Expand";
const Expand = memo(themed(Icon));
export {
  Expand
};
//# sourceMappingURL=expand.js.map
